/**
 * Issue Contract — Barrel re-export.
 *
 * ARCHITECTURE v4.0 — Phase 1, Step 1.0
 *
 * Originally a 770-line monolith. As of Sprint 5 (C1) the contents live in
 * focused modules and this file re-exports them so existing imports keep working:
 *
 *  - issues/codes.ts      → ISSUE_CODES + IssueCode + IssueKind + IssueDomain + PipelineStage
 *  - issues/types.ts      → ValidationIssue + GateVerdict + GateResult + PipelineResult + PipelineBatchResult
 *  - issues/builders.ts   → blocker / coach / info / createIssueSignature / computeIssuePenalty / deduplicateIssues
 *  - gate/evaluate.ts     → GateThresholds + DEFAULT_GATE_THRESHOLDS + evaluateGate
 *
 * Design principles (unchanged):
 * - N5: Issue determinism — same input → same issues (signature-based dedup)
 * - N4: Issue Contract governs gates; scoring never overrides blockers
 * - N6: No silent data correction in production
 */

export {
  ISSUE_CODES,
  type IssueCode,
  type IssueDomain,
  type IssueKind,
  type PipelineStage,
} from './issues/codes'

export {
  type GateResult,
  type GateVerdict,
  type PipelineBatchResult,
  type PipelineResult,
  type ValidationIssue,
} from './issues/types'

export {
  blocker,
  coach,
  computeIssuePenalty,
  createIssueSignature,
  deduplicateIssues,
  info,
} from './issues/builders'

export {
  DEFAULT_GATE_THRESHOLDS,
  type GateThresholds,
  evaluateGate,
} from './gate/evaluate'
